export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Разработка',
        path: '/cases/development',
    },
];

export const listTitle = [
    {
        title: 'Новая версия сайта Почта&nbsp;Банка',
        subtitle:
            'Интересный и&nbsp;архитектурно уникальный проект с&nbsp;интеграцией конструктора сайта на&nbsp;React в&nbsp;коробочное решение 1С-Битрикс.',
        description: [
            {
                name: 'Отрасль',
                details: 'Финтех',
            },
            {
                name: 'Услуги',
                details: 'Разработка, техническая поддержка',
            },
            {
                name: 'Технологии',
                details:
                    'PHP, Bitrix Framework, Nextjs, React, TypeScript, Kubernetes, Yandex&nbsp;Cloud, Tina.io',
            },
        ],
        company: 'Почта Банк',
        companyLink: 'https://www.pochtabank.ru/',
        companyLinkName: 'pochtabank.ru',
        text: 'Первый и&nbsp;единственный почтовый банк страны. Основные направления деятельности: кредитование физических и&nbsp;юридических лиц, инвестиционные продукты, услуги для бизнеса и&nbsp;финансовых организаций.',
        info: `Победитель <a href="https://workspace.ru/awards/cases/?stage=winners" target="_blank" rel="noopener noreferrer nofollow">Workspace Digital Awards-2023</a>&nbsp;в категории &laquo;Лучшие сайты для финансовой сферы&raquo;`,
        icon: '/images/svg/new-pochtabank/logotitleWDA.svg',
    },
];

export const listStages = [
    {
        number: '1.',
        text: 'Редизайн проекта.',
    },
    {
        number: '2.',
        text: 'Внедрение современного быстрого стека на&nbsp;фронте.',
    },
    {
        number: '3.',
        text: 'Смена Платформы на&nbsp;1С-Битрикс.',
    },
    {
        number: '4.',
        text: 'Развертывание облачной архитектуры.',
    },
    {
        number: '5.',
        text: 'Создание инструментов для удобного управления гипотезами маркетинга.',
    },
];

export const listStagesAudit = [
    {
        number: '1.',
        text: 'серьезные ошибки в&nbsp;оптимизации мета-тегов и&nbsp;заголовков&nbsp;h1;',
    },
    {
        number: '2.',
        text: 'старый &laquo;движок&raquo; на&nbsp;базе C# делал поддержку проекта дорогой и&nbsp;не&nbsp;оперативной;',
    },
    {
        number: '3.',
        text: 'большое количество накопившегося технического долга и&nbsp;недостаточная документируемость проекта;',
    },
    {
        number: '4.',
        text: 'архитектура решения, которая, как часто это бывает в&nbsp;процессе развития, уже не&nbsp;позволяла гибко решать текущие задачи.',
    },
];

export const listStagesAuditFooter = [
    {
        number: '1.',
        text: 'большое количество подрядчиков, работающих с&nbsp;этой системой;',
    },
    {
        number: '2.',
        text: 'широкий функционал, закрывающий многие задачи клиента &laquo;из&nbsp;коробки&raquo;;',
    },
    {
        number: '3.',
        text: 'отличная готовая админка, привычная менеджерам.',
    },
];

export const listFrontend = [
    {
        icon: '/images/svg/new-pochtabank/1c-bitrix.svg',
        text: '1C-Bitrix',
    },
    {
        icon: '/images/svg/new-pochtabank/next.svg',
        text: 'Next.js',
    },
    {
        icon: '/images/svg/new-pochtabank/react.svg',
        text: 'React',
    },
    {
        icon: '/images/svg/new-pochtabank/kuber.svg',
        text: 'Kubernetes',
    },
];

export const listNextjs = [
    {
        text: 'сжатие и&nbsp;минификация через самые современные инструменты;',
    },
    {
        text: 'модульная архитектура&nbsp;JS позволяет легко делать динамические и&nbsp;&laquo;ленивые&raquo; подгрузки кода, не&nbsp;изобретая своих велосипедов;',
    },
    {
        text: 'TreeShaking для минимальной загрузки кода на&nbsp;проект;',
    },
    {
        text: 'динамическая адаптация изображений для разных устройств и&nbsp;форматов: закрывает всю матрицу пересечений браузер х&nbsp;формат х&nbsp;разрешение экрана;',
    },
    {
        text: 'динамические шрифты для ускорения загрузки страницы;',
    },
    {
        text: 'переходы между страницами без перезагрузки всего приложения&nbsp;(SPA);',
    },
    {
        text: 'автоматический gzip компрессор статики;',
    },
    {
        text: 'удобное управление приоритетами загрузки third party скриптов;',
    },
    {
        text: 'свой статический кеш страниц.',
    },
];

export const listInstruments = [
    {
        icon: '/images/svg/new-pochtabank/react.svg',
        text: 'React',
    },
    {
        icon: '/images/svg/new-pochtabank/storybook.svg',
        text: 'Storybook',
    },
    {
        icon: '/images/svg/new-pochtabank/typescript.svg',
        text: 'Typescript',
    },
    {
        icon: '/images/svg/new-pochtabank/react.svg',
        text: 'SWC',
    },
    {
        icon: '/images/svg/new-pochtabank/eslint.svg',
        text: 'Eslint',
    },
    {
        icon: '/images/svg/new-pochtabank/next.svg',
        text: 'Next.js',
    },
];

export const listInstrumentsTable = [
    {
        type: 'Тип',
        instrument: 'Инструмент',
        comment: 'Комментарий',
    },
    {
        type: 'Front-End Framework/шаблонизатор',
        instrument: 'Next.Js/React',
        comment: 'Самые популярные в&nbsp;своем классе инструменты в&nbsp;мире (npm trends)',
    },
    {
        type: 'Язык',
        instrument: 'TypeScript',
        comment:
            'Обеспечивает уменьшение количества ошибок на&nbsp;уровне разработки нежели просто&nbsp;JS',
    },
    {
        type: 'Сборка',
        instrument: 'SWC',
        comment: 'Самый быстрый инструмент компиляции',
    },
    {
        type: 'Библиотека компонентов',
        instrument: 'StoryBook',
        comment: 'Обеспечивает документацию компонентов, повышает переиспользуемость',
    },
    {
        type: 'Обеспечение качества кода',
        instrument: 'Eslint/Prettier',
        comment:
            'Позволяют команде писать код по&nbsp;принятым стандартам и&nbsp;не&nbsp;отклонятся от&nbsp;них. При помощи Husky разработчик не&nbsp;может отправить код оформленный не&nbsp;по&nbsp;стандарту',
    },
];

export const listConstructor = [
    {
        number: '1.',
        text: 'Наличие визуального конструктора блоков.',
    },
    {
        number: '2.',
        text: 'Библиотека блоков.',
    },
    {
        number: '3.',
        text: 'Наличие параметризации блоков.',
    },
    {
        number: '4.',
        text: 'Возможность в&nbsp;некоторых случаях вкладывать одни блоки в&nbsp;другие.',
    },
    {
        number: '5.',
        text: 'Зависимость блоков, страниц от&nbsp;геолокации.',
    },
    {
        number: '6.',
        text: 'Возможность править группы страниц, меняя конкретный блок сразу у&nbsp;всей группы.',
    },
    {
        number: '7.',
        text: 'Версионирование страниц и&nbsp;блоков, чтобы сохранялась история изменения и&nbsp;возможность откатить изменение.',
    },
];

export const listStability = [
    {
        img: '/images/svg/new-pochtabank/grafana.svg',
        text: 'grafana',
    },
    {
        text: 'ELK',
    },
    {
        img: '/images/svg/new-pochtabank/Prometheus.svg',
        text: 'Prometheus',
    },
    {
        img: '/images/svg/new-pochtabank/Sentry.svg',
        text: 'Sentry',
    },
    {
        img: '/images/svg/new-pochtabank/Istio.svg',
        text: 'Istio',
    },
];
